import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";

import Nav from "../nav/Nav";
import { ReactComponent as LogoWithCopy } from "../../Assets/images/logo-with-copy.svg";

import "./Header.scss";

const Header = () => {
  const [menuOpened, setMenuOpened] = useState(false);

  useEffect(() => {
    const toggle = (el: Element) => {
      el.classList.toggle("menuOpened", menuOpened);
    };
    toggle(document.body);
    toggle(document.documentElement);
  }, [menuOpened]);

  function closeMenu() {
    setMenuOpened(false);
  }

  function handleHamburgerClick() {
    setMenuOpened((open) => !open);
  }

  return (
    <header className="main-header">
      <div className="main-container">
        <div className="main-header-container">
          <NavLink className="logo-link" to="/" onClick={closeMenu}>
            <LogoWithCopy className="logo" alt="Coifferie EM" />
          </NavLink>
          <Nav
            closeMenu={closeMenu}
            handleHamburgerClick={handleHamburgerClick}
            menuOpened={menuOpened}
          />
        </div>
      </div>
    </header>
  );
};

export default Header;
